package team.platforma.chatdata.table

import kotlin.Long
import kotlin.String

public data class Draft(
  public val draftID: Long,
  public val aiModelID: Long,
  public val userID: Long,
  public val chatID: Long,
  public val text: String,
)
